import { string } from 'prop-types'
import { kuiperClassNames, formatMentions } from '@opallabs/kuiper'

import './styles.scss'

const ApprovalInfo = ({ feedback }) => (
  <div className={kuiperClassNames('approval-info')}>
    {formatMentions(feedback)}
  </div>
)

ApprovalInfo.propTypes = {
  feedback: string,
}

export default ApprovalInfo
